<app-filter-panel [fields]="fieldsConfig" (search)="search()"></app-filter-panel>

<!--
<div class="flex gap-2">
  <span class="w-full input-field p-input-icon-right">
    <input pInputText  placeholder="Nombre" [(ngModel)]="filters.name.value" (keydown.enter)="search()" class="w-full"/>
    <i *ngIf="filters.name.value" class="pi pi-times cursor-pointer" (click)="filters.name.value = null; search()"></i>
  </span>
  
  <span class="w-full input-field p-input-icon-right">
    <input pInputText  placeholder="Email" [(ngModel)]="filters.username.value" (keydown.enter)="search()" class="w-full"/>
    <i *ngIf="filters.username.value" class="pi pi-times cursor-pointer" (click)="filters.username.value = null; search()"></i>
  </span>
</div>
-->

<p-table #grid [value]="mailsAccounts" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading" [paginator]="true"
          [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
          currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
          [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th pSortableColumn="name">Nombre<p-sortIcon field="name"></p-sortIcon></th>
      <th pSortableColumn="username" width="250" >Email <p-sortIcon field="username"></p-sortIcon></th>
      <th pSortableColumn="smtpEnabled" width="100" >SMTP <p-sortIcon field="smtpEnabled"></p-sortIcon></th>
      <th pSortableColumn="imapEnabled" width="100" >IMAP <p-sortIcon field="imapEnabled"></p-sortIcon></th>
      <th pSortableColumn="allowMailboxViewer" width="150">Mostrar buzón <p-sortIcon field="allowMailboxViewer"></p-sortIcon></th>
      <th pSortableColumn="isSystem" width="120" >Sistema <p-sortIcon field="isSystem"></p-sortIcon></th>
      <th width="100"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-mailAccount let-columns="columns">
    <tr (dblclick)="edit(mailAccount.id)">      
      <td> {{mailAccount.name}} </td>
      <td> {{mailAccount.username}} </td>
      <td>
        <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': mailAccount.smtpEnabled, 'text-red-500 pi-times-circle': !mailAccount.smtpEnabled }"></i>
      </td>
      <td>
        <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': mailAccount.imapEnabled, 'text-red-500 pi-times-circle': !mailAccount.imapEnabled }"></i>
      </td>
      <td>
        <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': mailAccount.allowMailboxViewer, 'text-red-500 pi-times-circle': !mailAccount.allowMailboxViewer }"></i>
      </td>
      <td>
        <p-tag *ngIf="mailAccount.isSystem" value="Sistema" severity="info"></p-tag>
      </td>
      <td>
        <div class="flex gap-2 justify-content-end">
          <p-button *ngIf="allowDelete" (click)="delete(mailAccount)" [rounded]="true" [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
          <p-button *ngIf="mailAccount.allowMailboxViewer" (click)="open(mailAccount.id)" [rounded]="true" [text]="false"><i class="pi pi-envelope"></i></p-button>
          <p-button *ngIf="allowWrite" (click)="edit(mailAccount.id)" [rounded]="true" [text]="false"><i class="pi pi-pencil"></i></p-button>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
        <td [attr.colspan]="3">
            No se ha encontrado informes
        </td>
    </tr>
</ng-template>
</p-table>

<p-confirmDialog></p-confirmDialog>